// import _ from "lodash";
// import gd from "../../../../app/web/gd/gd";

// const debug = "UserSettingsFtue"
const debug = false

export default class UserSettingsFtue {

    static normalize(initialData:any) {
        return {
            watchedVideos:          _.get(initialData, 'watchedVideos', []),
            watchedTours:           _.get(initialData, 'watchedTours', []),
            warningTourInMoreMenu:  _.get(initialData, 'warningTourInMoreMenu', true),
        }
    }


    static isTourWatched(tourId:string) {
        debug && console.log(debug, "isTourWatched()", tourId, gd.user.clientData.ftue.watchedTours)
        return gd.user.clientData.ftue.watchedTours.includes(tourId);
    }

    static markTourWatched(tourId:string) {

        debug && console.log(debug, "markTourWatched()", tourId )

        const watched = _.intersection(gd.user.clientData.ftue.watchedTours.slice(), gd.const.tours.availableTours); // just to clear ids
        watched.push(tourId);

        gd.user.clientData.ftue.watchedTours = _.uniq(watched);
        gd.user.saveClientData();
    }

    static markTourNotWatched(tourId:string) {
        gd.user.clientData.ftue.watchedTours.remove(tourId)

        // no need to save here
    }

    static isWarningRequired() {
        return gd.user.clientData.ftue.warningTourInMoreMenu;
    }

    static disableTourWarning() {
        gd.user.clientData.ftue.warningTourInMoreMenu = false;
        gd.user.saveClientData();
    }
}
